import axios from 'axios';
import imageCompression from 'browser-image-compression';

function formatDateToYYYYMMDD(date) {
  if (!(date instanceof Date) || isNaN(date)) return null; // Validate input

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits
  const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits

  return `${year}-${month}-${day}`;
}
const API_BASE_URL = 'https://lux.prod.pmi.zenown.com'; // Update with actual backend URL
const ApiKey = 'TesTingPMI_KEyFor_zenOWN';

const LuxService = {
  token: null, // Store JWT token internally

  // Set token for authorization headers
  setToken: (newToken) => {
    LuxService.token = newToken;
  },

  // Get headers with token
  getAuthHeaders: () => ({
    Authorization: `${LuxService.token}`,
  }),

  // JWT Authentication
  authenticate: async (apiKey) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/jwt`, { apiKey });
      const { token } = response.data;
      LuxService.setToken(token); // Store token internally
      return response.data;
    } catch (error) {
      console.error(
        'Error authenticating:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },
  // is returning
  isPhoneReturning: async (phone_number,flow) => {
    let user_type = undefined;
    if (LuxService) {
      if(flow+'' === '3'){
        user_type = 'MGM';
      }
      else if(flow+'' === '2'){
        user_type = 'LEAD_GENERATION';
      }
      else{
        user_type = 'FIRST_DEVICE';
      }
      let token = await LuxService.authenticate(ApiKey);
      LuxService.token = token;
      LuxService.setToken(token);

      //throw new Error('Authentication required.');
    }

    const body = {
      phone_number,
      user_type
    };

    try {
      const response = await axios.post(`${API_BASE_URL}/is_returning`, body, {
        headers: {
          ...LuxService.getAuthHeaders(),
        },
      });
      return response.data;
    } catch (error) {
      console.error(
        'Error uploading and analyzing document:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },

  // Upload and analyze document
  uploadAndAnalyzeDocument: async (file, uuid) => {
    if (LuxService) {
      let token = await LuxService.authenticate(ApiKey);
      LuxService.token = token;
      LuxService.setToken(token);
      //throw new Error('Authentication required.');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('uuid', uuid);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/upload_and_analyzing_document`,
        formData,
        {
          headers: {
            ...LuxService.getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        'Error uploading and analyzing document:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },

  // Create user
  createUser: async (userData, luxresident = true) => {
    if (LuxService) {
      let token = await LuxService.authenticate(ApiKey);
      LuxService.token = token;
      LuxService.setToken(token);
      //throw new Error('Authentication required.');
    }

    try {
     /* if(userData?.flowNumber  === 3 ){
        userData.first_name = 'MGM';
        userData.last_name = 'User';
        userData.email = Date.now()+'@gmail.com';
        userData.zip = 'xxxx';
      }
       else if(userData?.flowNumber  === 2 ){
        userData.zip = '0000';
        userData.email = userData?.email?.length <= 0  ?  Date.now()+'-test@gmail.com': userData?.email;

      }*/
      const response = await axios.post(
        `${API_BASE_URL}/${!userData?.isReturning && userData?.flowNumber === 1 && userData?.storeHasCouponlogic && userData?.country?.includes('lux') && !userData?.devices?.length  ? 'first_device' : userData?.flowNumber === 2 ? 'lead_user' : userData?.flowNumber === 3 ? 'mgm_user' : 'create_user'}`,
        userData?.country?.includes('lux')
          ? {
              first_name: userData?.firstname,
              last_name: userData?.lastname,
              phone_number: userData?.phonenumber,
              country: userData?.country,
              zip: userData?.zip,
              email: userData?.email,
              consent_1: userData?.agreements[0],
              consent_2: userData?.agreements[1],
              consent_3: userData?.country?.includes('lux') ? userData?.agreements[2] : false,
              uuid: userData?.uuid,
              device_image_uuid: userData?.deviceUuid,
              device_code: userData?.code
                ?.match(/.{0,3}/g)
                .join(' ')
                .slice(0, -1),
              shop_id: userData?.shopId || localStorage.getItem('shopId') || 1,
              language: userData?.language || 'en',
              is_returning: userData?.isReturning,
              date_of_birth: formatDateToYYYYMMDD(userData?.dob),
              user_uuid: userData?.user_uuid,
              flowNumber: userData?.flowNumber || 1,
              mgm: userData?.mgm || false,
            }
          : {
              country: userData?.country,
              consent_1: true,
              consent_2: true,
              consent_3: userData?.country?.includes('lux') ? userData?.agreements[2] : false,
              device_image_uuid: userData?.deviceUuid,
              device_code: userData?.code
                ?.match(/.{0,3}/g)
                .join(' ')
                .slice(0, -1),
              date_of_birth: formatDateToYYYYMMDD(userData?.dob),
              shop_id: userData?.shopId || localStorage.getItem('shopId') || 1,
              language: userData?.language,
              user_uuid: userData?.user_uuid,
              flowNumber: userData?.flowNumber || 1,
              mgm: userData?.mgm || false,
            },
        {
          headers: LuxService.getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        'Error creating user:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },

  // Validate phone number
  validatePhoneNumber: async (pin, pinId) => {
   // return {data: { success: true,verified:true },verified:true}; // Mocked response for testing
    if (LuxService) {
      let token = await LuxService.authenticate(ApiKey);
      LuxService.token = token;
      LuxService.setToken(token);
      //throw new Error('Authentication required.');
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/validate_phone_pin`,
        {
          pin,
          pin_id: pinId,
        },
        { headers: LuxService.getAuthHeaders() }
      );

      return response;
    } catch (error) {
      return { status: 'error' };
    }
  },

  // Reset phone number validation
  resetPhoneNumberValidation: async (phoneNumber, language) => {
   // return {data:{pinId: '123'},pinId: '123'}; // For testing purposes, remove this line in production
    if (LuxService) {
      let token = await LuxService.authenticate(ApiKey);
      LuxService.token = token;
      LuxService.setToken(token);
      //throw new Error('Authentication required.');
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/request_phone_pin`,
        { phone_number: phoneNumber, language },
        {
          headers: LuxService.getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        'Error resetting phone number validation:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },

  // Authenticate API
  authenticateApi: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/authenticate`);
      return response.data;
    } catch (error) {
      console.error(
        'Error authenticating API:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },

  // File Upload API
  uploadFile: async (file) => {
    if (LuxService) {
      let token = await LuxService.authenticate(ApiKey);
      LuxService.token = token;
      LuxService.setToken(token);
      //throw new Error('Authentication required.');
    }

    const formData = new FormData();
    formData.append('file', await resize_image(file));

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/upload`,
        formData,
        {
          headers: {
            ...LuxService.getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        'Error uploading file:',
        error?.response?.data || error.message
      );
      throw error?.response?.data;
    }
  },
};
async function resize_image(file) {
  console.log(`Before: compressedFile size ${file.size / 1024 / 1024} MB`);

  const options = {
    maxSizeMB: 1.6, // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 2400, // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 5, // optional, max number of iteration to compress the image (default: 10)
    fileType: 'image/jpeg',
  };

  try {
    const compressedFile = await imageCompression(file, options);
    console.log(
      'compressedFile instanceof Blob',
      compressedFile instanceof Blob
    ); // true
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
    file = compressedFile;
    return compressedFile;
  } catch (error) {
    console.log(error);
    return file;
  }
}
export default LuxService;
